import { atom } from 'jotai';
import type { FeedbackCacheItem } from 'shared/src/api/feedbackService/types';

/**
 * 상품카드 피드백 오버레이 캐시
 * key: `${instanceId}:${goodsSno}` (화면 인스턴스별 격리)
 *
 * 피드백 제출 후 상품카드 위에 오버레이를 표시하고,
 * 실행 취소 시 해당 항목을 제거하는 데 사용
 */
export const feedbackCacheAtom = atom<Map<string, FeedbackCacheItem>>(
  new Map(),
);
